/* this file is transformed by vux-loader */
/* eslint-disable */
import _defineProperty from "/home/travis/build/moohng/wchat/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";

var _mutations;

import * as types from "./mutation-types";
var mutations = (_mutations = {}, _defineProperty(_mutations, types.UPDATE_LOADING_STATUS, function (state, _ref) {
  var loading = _ref.loading;
  var loadingNum = state.loading;
  state.loading = loading ? loadingNum + 1 : loadingNum - 1;
}), _defineProperty(_mutations, types.UPDATE_INVALID_RESPONSE, function (state, _ref2) {
  var invalidResponse = _ref2.invalidResponse;
  state.invalidResponse = invalidResponse;
}), _mutations);
export default mutations;